const pageName = 'yourOrderPage';
const clickEvents = {
  filterToBeShippedOrdersButton: {
    pageName,
    buttonName: 'filterToBeShippedOrders'
  },
  filterToBeDeliveredOrdersButton: {
    pageName,
    buttonName: 'filterToBeDeliveredOrders'
  },
  filterToBeReviewedOrdersButton: {
    pageName,
    buttonName: 'filterToBeReviewedOrders'
  },
  filterCancelledOrdersButton: {
    pageName,
    buttonName: 'filterCancelledOrders'
  },
  checkMyOrderDetailButton: {
    pageName,
    buttonName: 'checkMyOrderDetail'
  },
  submitReturnButton: {
    pageName,
    buttonName: 'submitReturn'
  },
  buyAgainButton: {
    pageName,
    buttonName: 'buyAgain'
  },
  cancelOrderButton: {
    pageName,
    buttonName: 'cancelOrder'
  },
  showAlreadyReviewedButton: {
    pageName,
    buttonName: 'showAlreadyReviewed'
  },
  goToReviewButton: {
    pageName,
    buttonName: 'goToReview'
  }
};
const loadingEvents = {
  yourOrderPage: {
    pageName,
    eventName: 'ATF'
  },
  filterAllOrders: {
    pageName,
    eventName: 'filterAllOrders'
  },
  filterToBeShippedOrders: {
    pageName,
    eventName: 'filterToBeShippedOrders'
  },
  filterToBeDeliveredOrders: {
    pageName,
    eventName: 'filterToBeDeliveredOrders'
  },
  filterToBeReviewedOrders: {
    pageName,
    eventName: 'filterToBeReviewedOrders'
  },
  filterCancelledOrders: {
    pageName,
    eventName: 'filterCancelledOrders'
  }
};

export default {
  clickEvents,
  loadingEvents
};
